import Accordion from "@mui/material/Accordion";
import styled from "styled-components";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
export const HXAccordion = styled(Accordion) `
    box-shadow: none;

    // Customize border between items
    &::before {
        background-color: ${colors.black_12};
        height: 1px;
        top: 0;
    }

    // Built-in accordion likes to hide the dividers in a variety of
    // circumstances. We don't want this.
    &::before,
    &.Mui-expanded::before,
    &.Mui-expanded::before,
    &.Mui-expanded + &&.Mui-expanded::before {
        opacity: 1;
        display: block;
    }

    // Hide the divider above the first item, we
    // only want dividers _between_ items
    &:first-of-type::before {
        display: none;
    }

    // Hide extra space between elements when expanded
    &.Mui-expanded {
        margin: 0;
    }

    // Make the expand icon (down chevron) bigger
    & .MuiAccordionSummary-expandIconWrapper svg {
        font-size: 24px !important;
        color: ${colors.black_lighter};
    }

    // Custom formatting of content when collapsed
    & .MuiAccordionSummary-root {
        height: 40px;
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        align-items: center;

        // Override the existing min-height of 64px which
        // makes the summary text shift down distractingly
        &.Mui-expanded {
            min-height: 48px;
        }
    }

    & .MuiAccordionSummary-content {
        color: ${colors.black_main};
        font-weight: ${fontWeights.SEMI_BOLD};
        margin: 0;

        &.Mui-expanded {
            margin: 0;
        }
    }

    // Custom formatting of content when expanded
    & .MuiAccordionDetails-root {
        padding: 8px 16px 16px 16px;
        color: ${colors.black_light};
    }
`;
